module.exports = "/images/agent-and-loan-officer.png?ac4a890b35ccc810c913979575725f62";